import { ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy, ViewEncapsulation } from "@angular/core";
import { Jurisdiction } from "@obg/core.config";
import { DialogService } from "@obg/mat.ui.core";
import { TermsAndConditionsConfigService, TermsAndConditionsService, TermsAndConditionsVersion } from "@obg/ngx.common";
import { Subject, Subscription } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";

import { TermsAndConditionsModalContainer } from "../terms-and-conditions-modal/terms-and-conditions-modal.container";

@Component({
	selector: "obg-m-sm-terms-and-conditions-history-container",
	templateUrl: "./sm-terms-and-conditions-history.container.html",
	styleUrls: ["./sm-terms-and-conditions-history.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SmTermsAndConditionsHistoryContainer implements OnDestroy {
	@HostBinding("class.obg-m-sm-terms-and-conditions-history") class = true;

	@Input() termsAndConditionsDocumentsHistory: TermsAndConditionsVersion[] = [];
	@Input() jurisdiction: Jurisdiction | undefined;

	isDownloadLatestAcceptedContentEnabled = this.termsAndConditionsConfigService.isLatestAcceptedContentEnabled();

	displayedColumns: string[] = ["description", "issuedOn", "acceptedOn", "documentLink"];

	private destroy$ = new Subject<void>();

	constructor(
		private dialogService: DialogService,
		private termsAndConditionsConfigService: TermsAndConditionsConfigService,
		private termsAndConditionsService: TermsAndConditionsService
	) {}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	onTermsAndAgreementsClick(
		termsAndConditionsDocument: TermsAndConditionsVersion,
		index: number
	): Subscription | void {
		if (this.isDownloadLatestAcceptedContentEnabled && index === 0) {
			return this.downloadTermsAndConditions$$();
		}

		this.openModal(termsAndConditionsDocument);
	}

	openModal(termsAndConditionsVersion: TermsAndConditionsVersion) {
		this.dialogService.openComponent(TermsAndConditionsModalContainer, {
			data: { document: "terms-and-conditions", version: termsAndConditionsVersion },
		});
	}

	private downloadTermsAndConditions$$(): Subscription {
		return this.termsAndConditionsService
			.getLatestAcceptedContent()
			.pipe(
				tap((data) => {
					if (this.jurisdiction === "COGA") {
						const latestTermsAndConditionsDocument = this.termsAndConditionsDocumentsHistory[0];
						const fileName = `terminos-y-condiciones-${latestTermsAndConditionsDocument.majorVersion}-${latestTermsAndConditionsDocument.minorVersion}.pdf`;

						return this.termsAndConditionsService.downloadPdfFile(data, fileName);
					}
				}),
				takeUntil(this.destroy$)
			)
			.subscribe();
	}
}
